var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowButtonDownWhite = function SvgArrowButtonDownWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m.249 7.207 10.984 12.471a1.066 1.066 0 0 0 1.539 0L23.751 7.207a.987.987 0 0 0-.107-1.414l-1.85-1.557a1.03 1.03 0 0 0-1.438.111L12.191 13.8a.25.25 0 0 1-.379 0L3.644 4.346A1.02 1.02 0 0 0 2.948 4a1 1 0 0 0-.741.238L.356 5.793A.99.99 0 0 0 0 6.478a.98.98 0 0 0 .249.729"
  })));
};
export default SvgArrowButtonDownWhite;